<template>
    <fragment v-if="isLoading">
        <div id="wrap" class="landing_wrap pb-0">
            <div class="dim"></div>
            <div class="container_wrap">
                <!-- Loading -->
                <div class="loader_table">
                    <div class="loader_box">
                        <div class="loader">
                            <span class="sr_only">Loading...</span>
                        </div>
                    </div>
                    <p v-if="!isError">Loading</p>
                    <p v-else v-html="errorMsg"></p>
                </div>
                <!-- //Loading -->
            </div>
        </div>
    </fragment>
    <fragment v-else>
        <div id="container">
            <div class="container_wrap">
                <!-- contents -->
                <div id="contents">
                    <div class="contents_wrap">
                        <!-- contents_head -->
                        <h2 class="pg_title">{{ $t('FIELD.GLOBAL.DETAILS') }}</h2>
                        <!-- //contents_head -->
                        <div class="view_cont" v-if="!isLoading">
                            <div class="view_info">
                                <div class="view_category" v-if="typeof detail.PRD_CATEGORY_NM1 !== 'undefined'">
                                    {{ detail.PRD_CATEGORY_NM1 }}
                                    <em v-if="typeof detail.PRD_CATEGORY_NM2 !== 'undefined'">&gt;</em> {{ detail.PRD_CATEGORY_NM2 }}
                                    <em v-if="typeof detail.PRD_CATEGORY_NM3 !== 'undefined'">&gt;</em> {{ detail.PRD_CATEGORY_NM3 }}
                                </div>
                            </div>
                            <dl class="view_subject">
                                <dt class="subject">
                                    <em v-if="detail.IMPORTANCE_YN === 'Y'" class="textcolor_important">[{{ $t('FIELD.GLOBAL.IMPORTANT') }}]</em>
                                    <em v-else-if="detail.MUST_READ_YN === 'Y'" class="textcolor_must">[{{ $t('FIELD.GLOBAL.MUSTREAD') }}]</em>
                                    {{ detail.KNOWLEDGE_TITLE | refTitle | decodeXSS }}
                                </dt>
                                <dd class="desc">
                                    <span class="desc_Regist">
                                        <em>{{ $t('FIELD.GLOBAL.REGISTERED.BY') }}</em>
                                        {{ detail.REG_USER }} ({{ detail.REG_DT }})
                                    </span>
                                    <span class="desc_modify">
                                        <em>{{ $t('FIELD.GLOBAL.MODIFY.USER') }}</em>
                                        {{ detail.MODF_USER }} ({{ detail.MODF_DT }})
                                    </span>
                                </dd>
                            </dl>

                            <!-- tab -->
                            <div class="view_desc">
                                <!-- 200420수정 S -->
                                <!-- SCMS Contents 의 경우, Symptom 및 Serial 등 추가 항목 -->
                                <table v-if="isSCMS" class="data_table_ty2 mb-20">
                                    <colgroup>
                                        <col width="20%">
                                        <col width="30%">
                                        <col width="20%">
                                        <col width="*">
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th class="text_left">{{ $t('FIELD.GLOBAL.SYMPTOM') }}</th>
                                            <td colspan="3">
                                                <ul class="in_dotlist" v-if="symptomList.length === 0">
                                                    <li>&nbsp;</li>
                                                </ul>
                                                <ul class="in_dotlist" v-else v-for="symptom in symptomList">
                                                    <li>{{ symptom.C_CODE_T_INFO }} > {{ symptom.CODE_T_INFO }}</li>
                                                </ul>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text_left">{{ $t('FIELD.KNOWLEDGE.MANUFACTURE') }}</th>
                                            <td>
                                                <ul class="in_dotlist">
                                                    <li v-if="typeof(detail.MANUFACTURE_S_DT) !== 'undefined'">
                                                        {{ (detail.MANUFACTURE_S_DT + '01') | dateFormat('MMM.YYYY') }} ~ {{ (detail.MANUFACTURE_E_DT + '01') | dateFormat('MMM.YYYY') }}
                                                    </li>
                                                </ul>
                                            </td>
                                            <th class="text_left">{{ $t('FIELD.QNA.SERIAL.NUMBER') }}</th>
                                            <td>
                                                <ul class="in_dotlist" v-if="serialList.length === 0">
                                                    <li>&nbsp;</li>
                                                </ul>
                                                <ul class="in_dotlist" v-else v-for="serial in serialList">
                                                    <li>{{ serial.SERIAL_S }} ~ {{ serial.SERIAL_E}}</li>
                                                </ul>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text_left">{{ $t('FIELD.KNOWLEDGE.GUIDETYPE') }}</th>
                                            <td>{{ getGuideTypeName }}</td>
                                            <th class="text_left">{{ $t('FIELD.KNOWLEDGE.DEFECTTYPE') }}</th>
                                            <td>{{ getDefectTypeName }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- //200420수정 E -->

                                <div class="tab_wrap">
                                    <ul class="tab_menu_02 tab_menus">
                                        <li class="on" @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.GLOBAL.DESCRIPTION') }}</a></li>
                                        <li @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.GLOBAL.MODEL.LIST') }}</a></li>
                                        <li @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.PARTSLISTS') }}</a></li>
                                        <li @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.VERHISTORY') }}</a></li>
                                    </ul>
                                    <div class="tab_contents">
                                        <div class="tab_cont" v-html="detail.KNOWLEDGE_DESC" />
                                        <div class="tab_cont" v-resize="setGridResizeColumn">
                                            <model-grid
                                                v-if="reloadModel"
                                                :gridId="modelGridId"
                                                :ref="modelGridId"
                                                :data="modelList"
                                                :columns="modelColumns"
                                                :options="options"
                                                :pageOptions="pageOptions"
                                                :isTotalCount="true"
                                            />
                                        </div>
                                        <div class="tab_cont" v-resize="setGridResizeColumn">
                                            <parts-grid
                                                v-if="reloadParts"
                                                :gridId="partsGridId"
                                                :ref="partsGridId"
                                                :data="partsList"
                                                :columns="partsColumns"
                                                :options="options"
                                                :pageOptions="pageOptions"
                                                :isTotalCount="true"
                                            />
                                        </div>
                                        <div class="tab_cont">
                                            <!-- Version Tab -->
                                            <table class="data_table">
                                                <colgroup>
                                                    <col width="15%">
                                                    <col width="15%" class="pc_only">
                                                    <col width="25%" class="pc_only">
                                                    <col width="*">
                                                </colgroup>
                                                <thead>
                                                    <tr>
                                                        <th>{{ $t('FIELD.GLOBAL.VERSION') }}</th>
                                                        <th class="pc_only">{{ $t('FIELD.GLOBAL.DATE') }}</th>
                                                        <th class="pc_only">{{ $t('FIELD.GLOBAL.EDITOR') }}</th>
                                                        <th>{{ $t('FIELD.GLOBAL.DETAILS') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody class="text_center">
                                                    <tr v-if="versionList.length > 0" v-for="(version, idx) in versionList">
                                                        <td>Ver.{{ version.VERSION_NO }}</td>
                                                        <td class="pc_only">{{ version.MODF_DT }}</td>
                                                        <td class="pc_only">{{ version.MODF_USER }}</td>
                                                        <td class="text_left">
                                                            {{ version.MODF_REASON | decodeXSS }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <!-- Attachment -->
                                <innorix-download
                                    v-if="attach.length > 0"
                                    :uploadId="uploadId"
                                    :serviceType="serviceType"
                                    :attachList="attach"
                                    :seq="getKnowledgeId"
                                />
                                <!-- //Attachment -->

                                <!-- 200622수정 S -->
                                <dl class="attachment_link" v-if="attach.length > 0">
                                    <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">Having trouble downloading?</a></dt>
                                    <dd>
                                        <ul>
                                            <li v-for="file in attach" :key="file.FILE_DIR">
                                                <a href="javascript:" @click="getDownloadUrl(file.ATTCH_FILE_SEQ)" class="txt_link">
                                                    <span class="ico_attach"></span> {{ file.FILE_NM }}
                                                </a>
                                            </li>
                                        </ul>
                                    </dd>
                                </dl>
                            </div>
                            <!-- 200622수정 E -->
                        </div>
                    </div>
                </div>
                <!-- contents -->
            </div>
        </div>
    </fragment>
</template>
<script>
import Vue                                  from 'vue';
import { mapGetters }                       from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import axios                                from 'axios';
import qs                                   from 'query-string';
import resize                               from 'vue-resize-directive'

import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import CrossEditorViewer                    from '~c/CrossEditorViewer';
import InnorixDownload                      from '~c/InnorixDownload';
import KnowledgeModelGrid                   from '~vb/knowledge/popup/KnowledgeModelGrid';
import KnowledgePartsGrid                   from '~vb/knowledge/popup/KnowledgePartsGrid';

const SCMS_CONTENTS_CD = MenuUtil.getScmsContents;

export default {
    name: 'KnowledgeViewer',
    props: {
        sk : { required: true }
    },
    data() {
        return {
            isLoading   : true,
            isError     : false,
            errorMsg    : SDLUtil.getMsgProp('MESSAGE.AUTH.NOAUTH'),

            window: { width: 0, height: 0 },

            knowledgeId: '',
            boardId: '',
            processStep: 0,
            modelList: [],
            modelColumnName: [],
            partsList: [],
            symptomList: [],
            serialList: [],
            satisfaction: [],
            attachImg: [],
            detail: {},
            attach: [],
            verifyList: [],
            versionList: [],
            isPrevious: false,
            isFavorite: false,
            isRepair: false,
            isSCMS: false,

            reloadModel: false,
            reloadParts: false,

            editorId: 'knowledgeViewerEditor',

            modelGridId: 'knowledgeViewerMdlGrid',
            modelColumns: [],

            partsGridId: 'knowledgeViewerPtsGrid',
            partsColumns: [],

            options: { scrollX: false, scrollY: true, minBodyHeight: 80, bodyHeight: 265 },
            pageOptions: { useClient: true, perPage: 20 },

            uploadId: 'knowledgeViewerDownload',
            serviceType: 'mail'
        }
    },
    directives: { resize },
    computed: {
        ...mapGetters({
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            params: 'getParams',
            popupParams: 'getPopupParams',
        }),
        getKnowledgeId()    { return this.knowledgeId; },
        getBoardId()        { return this.boardId; },
        getEditorId()       { return this.editorId; },
        getBoardCreationYN(){ return store.getters.getParams.creationYn || 'N'; },
        getDefectTypeName() {
            let defectType = this.detail.DEFECT_TYPE || '',
                defectTypeName = { "M":"Common", "C":"Call", "R":"Repair" };

            if(!SDLUtil.isNull(defectType)) {
                return defectTypeName[defectType];
            } else {
                return  '-';
            }
        },
        getGuideTypeName() {
            let guideType = this.detail.GUIDE_TYPE || '',
                guideTypeName = {"H":"H/W", "S":"S/W", "M":"Mechanical", "A":"Accessory", "I":"Info Sharing", "E":"Others"};

            if(!SDLUtil.isNull(guideType)) {
                return guideTypeName[guideType];
            } else {
                return  '-';
            }
        }
    },
    components: {
        'model-grid'        : KnowledgeModelGrid,
        'parts-grid'        : KnowledgePartsGrid,
        'cross-editor'      : CrossEditorViewer,
        'innorix-download'  : InnorixDownload
    },
    created() {
        // 화면 접근 시 해당 파라미터가 없으면 무조건 닫는다.
        if(StringUtil.isNull(this.sk)) {
            this.isError = true;
            SDLUtil.alert({
                title: 'TITLE.WARNING.TITLE',
                msg: 'MESSAGE.PROGRAM.END',
                onOkEvt: () => { window.close(); }
            });

        } else {
            let body = document.getElementsByTagName('body')[0];
            if(!body.classList.contains('fullpage_Wrap')) body.classList.add('fullpage_Wrap');

            this.knowledgeId = this.popupParams.knowledgeId;
            this.boardId = this.popupParams.boardId;

            window.addEventListener('resize', this.handleResize);
            this.handleResize();

            this.initLoad().then(res => {
                Vue.$log.info("▶ KnowledgeViewer.vue Response => ", res);
                if(res.success) {
                    this.symptomList = res.symptomList.rowData;
                    this.serialList = res.serialList.rowData;
                    this.modelList = res.modelList.rowData;
                    this.modelColumnName = res.modelList.columnName;
                    this.partsList = res.partsList.rowData;
                    this.satisfaction = res.satisfaction.rowData;
                    this.attachImg = res.attachImg.rowData;
                    this.detail = res.detail.rowData[0];
                    this.attach = res.attach.rowData;
                    this.verifyList = res.verifyList.rowData;
                    this.versionList = res.version.rowData;
                    this.modelColumns = this.getDynamicCols('MODEL');
                    this.partsColumns = this.getDynamicCols('PARTS');

                    this.knowledgeId = this.detail['KNOWLEDGE_ID'];
                    this.boardId = this.detail['BOARD_ID'];

                    // 즐겨찾기 확인
                    try{
                        if(this.detail['FAVORITE'] == 0) {
                            this.isFavorite = false;
                        } else {
                            this.isFavorite = true;
                        };

                    } catch(e) {
                        this.isFavorite = false;
                    };

                    // 이전 버전 존재 확인
                    try {
                        if(SDLUtil.isNull(this.detail['PREVIOUS_ID'])) {
                            this.isPrevious = false;
                        } else {
                            this.isPrevious = true;
                        };

                    } catch(e) {
                        this.isPrevious = false;
                    }

                    // SCMS 컨텐츠 확인
                    let menuGroupDetailCd = this.detail['MENU_GROUP_DETAIL_CD'] || '';
                    if( _.includes(SCMS_CONTENTS_CD, menuGroupDetailCd) ) {
                        if(menuGroupDetailCd === 'RT') this.isRepair = true;
                        this.isSCMS = true;
                    };

                    this.isLoading = false;

                } else {
                    this.isError = true;
                    this.errorMsg = res.errorMessage;
                }
                SDLUtil.showLoadingBar(false);
            });
        }
    },
    methods: {
        // initiation
        initLoad() {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/noauth/knowledge/detailViewer.skp`,
                    qs.stringify(this.sk),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                .then(res => {
                    return res.data;
                })
                .catch(err => {
                	alert("error");
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                    this.$router.push({ path: '/no_auth' });
                });
        },
        // 브라우저 리사이징 이벤트
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        // 그리드 컬럼 percent resize 용
        getDynamicCols(type = '') {
            let colType = type;
            if(SDLUtil.isNull(type)) {
                if(this.processStep === 1) {
                    colType = 'MODEL';

                } else if(this.processStep === 2) {
                    colType = 'PARTS';
                };
            }

            if(SDLUtil.isMobile()) {
                if(colType === 'MODEL') {
                    return [
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'), name: 'CDMODEL', align: 'center', resizable: true, sortable: true,
                                    filter: { type: 'text', showApplyBtn: true, showClearBtn: true, state: { code: 'contain'} } },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL'), name: 'NMMODEL', align: 'center', resizable: true, sortable: true },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MARKETINGNAME'), name: 'MAKETNM', align: 'center', resizable: true, sortable: true },
                        { header: 'CDCOMPANY', name: 'CDCOMPANY', hidden: true },
                        { header: 'CDGBM', name: 'CDGBM', hidden: true },
                    ];

                } else {
                    return [
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.CODE'), name: 'PARTS_CODE', align: 'center', resizable: true, sortable: true },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.TYPE'), name: 'PARTS_TYPE', align: 'center', resizable: true, sortable: true }
                    ];
                }

            } else {
                if(colType === 'MODEL') {
                    return [
                        /* 2020.06.26 Subsidiary 컬럼 삭제 */
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'), name: 'CDMODEL', align: 'center', width: this.getColumnSize(20), resizable: true, sortable: true,
                                    filter: { type: 'text', showApplyBtn: true, showClearBtn: true, state: { code: 'contain'} } },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL'), name: 'NMMODEL', align: 'center', width: this.getColumnSize(25), resizable: true, sortable: true },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MARKETINGNAME'), name: 'MAKETNM', align: 'center', width: this.getColumnSize(25), resizable: true, sortable: true },
                        { header: 'CDCOMPANY', name: 'CDCOMPANY', hidden: true },
                        { header: 'CDGBM', name: 'CDGBM', hidden: true },
                    ];

                } else {
                    return [
                        /* 2020.04.06 Parts Name 컬럼 삭제 */
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.CODE'), name: 'PARTS_CODE', align: 'center', width: this.getColumnSize(30), resizable: true, sortable: true },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.TYPE'), name: 'PARTS_TYPE', align: 'center', width: this.getColumnSize(25), resizable: true, sortable: true }
                    ];
                };
            };
        },
        getColumnSize(size) {
            if(isNaN(Number(size))) { return 0; }
            let gridWrapSize = document.getElementsByClassName('tab_cont').length ? document.getElementsByClassName('tab_cont')[this.processStep].clientWidth - 16 : 1000;
            return Math.floor((gridWrapSize - 50) / (100 / size));
        },
        
        setGridResizeColumn(e) {
            // 그리드 다이나믹 컬럼
            if(this.processStep === 1) {
                EventBus.$emit('model-grid-set-column', this.getDynamicCols('MODEL'));

            } else if(this.processStep === 2) {
                EventBus.$emit('parts-grid-set-column', this.getDynamicCols('PARTS'));
            }
        },
        changeTab(e) {
            let tabIndex = $('.tab_menus > li > a').index(e.target);
            this.processStep = tabIndex;

            if( $(e.target).hasClass('on') == true){
                $(e.target).parents('li').removeClass('on');
                $('.tab_wrap .tab_cont').hide();

            } else {
                $('.tab_wrap li').removeClass('on');
                $('.tab_wrap .tab_cont').hide();
                $(e.target).parents('li').addClass('on');
                $('.tab_wrap .tab_cont').eq(tabIndex).show();

                if(this.processStep === 1) {
                    this.modelList = this.modelList;
                    this.reloadModel = true;
                    this.getDynamicCols('MODEL');

                } else if(this.processStep === 2) {
                    this.partsList = this.partsList;
                    this.reloadParts = true;
                    this.getDynamicCols('PARTS');

                } else {
                    this.reloadModel = false;
                    this.reloadParts = false;
                }
            }

            EventBus.$emit('grid-refresh');
        },
        getDownloadUrl(SEQ) {
            let cmnApiBase = `${SDLUtil.API_URL}/noauth/attachDownload.skp`;
            return window.open(cmnApiBase + '?attachFileSeq=' + SEQ);
        },
        toggleLink(e) {
            $('.attachment_link > dd').toggle();
        },
    },
    mounted() {
        //
    },
    beforeDestroy() {
        Vue.$log.info('▶ KnowledgeViewer.vue beforeDestroy.');
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/gspnCon/CommonConnectBulletin.vue